import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["startDate", "endDate", "description", "descriptionCount"];

  connect() {
    this.validateDates();
    this.updateDescription();
  }

  validateDates() {
    if (!this.hasStartDateTarget || !this.hasEndDateTarget) return;

    const start = this.startDateTarget.value;
    const end = this.endDateTarget.value;
    this.endDateTarget.setCustomValidity(start && end && end < start ? "结束日期不能早于开始日期" : "");
  }

  updateDescription() {
    if (!this.hasDescriptionTarget || !this.hasDescriptionCountTarget) return;

    this.descriptionCountTarget.textContent = `${this.descriptionTarget.value.length} 字`;
  }
}
